module.exports = __webpack_public_path__ + "img/logo.d085fb10.png";